<template>
  <div
    class="member-profile-upload-field"
    :style="presentUploadFieldStyle"
    @click="handleImageUpload"
  >

    <div
      v-show="isImageAreaTargeted"
      class="hover-dimmed-layer"
    />
    <i
      v-show="!profileImageSrc"
      class="el-icon-plus center-icon"
    />
    <i
      v-show="isImageAreaTargeted"
      class="el-icon-search left-icon"
      @click="handleEnlargedImageDisplay"
    />
    <i
      v-show="isImageAreaTargeted"
      class="el-icon-delete right-icon"
      @click="handleProfileImageDelete"
    />

    <div 
      v-show="isEnlargedImageDisplayed" 
      class="member-profile-preview-wrapper"
      @click.prevent
    >
      <i
        class="el-icon-circle-close" 
        @click="handleEnlargedImageClose"
      />
      <img 
        alt="profile"
        :src="profileImageSrc" 
      />
    </div>

    <input
      ref="inputFileEl"
      type="file"
      accept="image/*"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'MemberDetailProfileImage',
  props: {
    originImageSrc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isProfileImageTargeted: false,
      isEnlargedImageDisplayed: false,
      isMobileWidth: window.innerWidth <= 768,
    };
  },
  computed: {
    profileImageSrc() {
      return this.originImageSrc;
    },
    isImageAreaTargeted() {
      const inDesktop = !this.isMobileWidth && this.profileImageSrc;
      const inMobile = this.isMobileWidth && this.isProfileImageTargeted;
      return Boolean(inDesktop || inMobile);
    },
    presentUploadFieldStyle() {
      if (this.profileImageSrc === '') {
        return {};
      };

      return {
        backgroundImage: `url(${this.profileImageSrc})`,
      };
    },
  },
  methods: {
    handleEnlargedImageDisplay() {
      if (!this.isEnlargedImageDisplayed) {
        this.isEnlargedImageDisplayed = true;
        this.isProfileImageTargeted = false;
      };
    },
    handleEnlargedImageClose() {
      this.isEnlargedImageDisplayed = false;
    },
    handleImageUpload() {
      if (this.profileImageSrc && this.isMobileWidth) {
        this.isProfileImageTargeted = !this.isProfileImageTargeted;
      }

      if (this.profileImageSrc) {
        return false;
      }

      this.$refs['inputFileEl'].click();
    },
    handleFileChange($event) {
      if ($event.target.files.length === 0) {
        return;
      };

      const imageFile = $event.target.files[0];

      if (imageFile.size > 3 * 1024 * 1024) {
        return this.$alert(
          '프로필 이미지의 크기가 3MB를 초과합니다.',
          '프로필 이미지 업로드 오류'
        );
      };

      this.$emit('change', imageFile);
    },
    async handleProfileImageDelete() {
      try {
        await this.$confirm(
          '프로필 사진을 삭제하시겠습니까? 삭제 시 복구가 불가합니다.',
          '프로필 사진 삭제',
          {
            confirmButtonText: '확인',
            cancelButtonText: '취소',
            showClose: false,
            customClass: 'fifl-message-box',
            confirmButtonClass: 'gray',
            cancelButtonClass: 'white',
            closeOnPressEscape: false,
          }
        );
        
        return this.$emit('delete');
      } catch (err) {
        return err;
      }

      return false;
    },
  },
};
</script>

<style lang="scss">
.member-profile-upload-field {
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  position: relative;
  transition: background-color 0.3s ease;
  overflow: hidden;

  .hover-dimmed-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: transparent;
    transition: background-color 0.3s ease;
  }

  input[type="file"] {
    display: none;
  }

  @mixin icon {
    position: absolute;
    top: calc(50% - 10px);
    font-size: 20px;
    width: 20px;
    height: 20px;
    text-align: center;
    font-weight: bold;
  }

  .center-icon {
    @include icon;
    left: calc(50% - 10px);
  }

  .left-icon {
    @include icon;
    left: calc(33% - 10px);
  }

  .right-icon {
    @include icon;
    right: calc(33% - 10px);
  }

  .el-icon-plus {
    color: #4a4a4a;
    transition: color 0.3s ease;
  }

  .el-icon-search {
    color: transparent;
    transition: color 0.3s ease;
  }
  .el-icon-delete {
    color: transparent;
    transition: color 0.3s ease;
  }

  @media screen and (min-width: 768px) {
    &:hover {
      background-color: #e1e1e1;
      cursor: pointer;

      .hover-dimmed-layer {
        background-color: rgba(74, 74, 74, 0.44);
      }

      .el-icon-delete {
        color: #ffffff;
      }

      .el-icon-search {
        color: #ffffff;
      }
    }
  }
  
  @media screen and (max-width: 768px) {
    .hover-dimmed-layer {
      background-color: rgba(74, 74, 74, 0.44);
    }

    .el-icon-delete {
      color: #ffffff;
    }

    .el-icon-search {
      color: #ffffff;
    }
  }

  .member-profile-preview-wrapper {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    background-color: rgba(74, 74, 74, 0.44);
    z-index: 2500;

    .el-icon-circle-close {
      position: absolute;
      top: 10%;
      right: 10%;
      color: #ffffff; 
    }

    img { 
      max-width: 60%;
    }
  }
}
</style>
